var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vs-divider"),
      _c("div", { staticClass: "row  mb-3" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "col-4 d-flex align-items-end justify-content-end" },
          [
            _c(
              "vs-button",
              {
                attrs: { color: "primary", icon: "add" },
                on: {
                  click: function($event) {
                    return _vm.addDistribution()
                  }
                }
              },
              [_vm._v(" Agregar distribución ")]
            )
          ],
          1
        )
      ]),
      _vm.distributions.length
        ? _c(
            "div",
            { staticClass: "row d-flex justify-content-center" },
            _vm._l(_vm.distributions, function(distribution, index) {
              return _c(
                "div",
                {
                  key: "distribution-" + index,
                  staticClass: "col-8 mt-3 border-bottom"
                },
                [
                  _c("div", { staticClass: "row text-center" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip:auto",
                            value: distribution.name,
                            expression: "distribution.name",
                            arg: "auto"
                          }
                        ],
                        staticClass: "col-5"
                      },
                      [_vm._v(" " + _vm._s(distribution.name) + " ")]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip:auto",
                            value: distribution.mail,
                            expression: "distribution.mail",
                            arg: "auto"
                          }
                        ],
                        staticClass: "col-5"
                      },
                      [_vm._v(" " + _vm._s(distribution.mail) + " ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("vs-icon", {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip",
                              value: "Remover distribución",
                              expression: "'Remover distribución'"
                            }
                          ],
                          staticStyle: { cursor: "pointer" },
                          attrs: {
                            color: "red",
                            icon: "highlight_off",
                            size: "small",
                            bg: "white",
                            round: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("remove-distribution", index)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "distribution",
          attrs: {
            size: "lg",
            "no-close-on-backdrop": "",
            "ok-title": "Agregar",
            "cancel-title": "Cancelar",
            title: "Agregar distribución"
          },
          on: { ok: _vm.handleOk, cancel: _vm.cancelNewDistribution }
        },
        [
          _c(
            "form",
            {
              attrs: {
                id: "new-distribution-form",
                autocomplete: "off",
                size: "sm",
                "data-vv-scope": "new-distribution"
              },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "label",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value:
                              "Como nos referimos a la persona" +
                              " a la que se le envie al finalizar",
                            expression:
                              "'Como nos referimos a la persona' +\n                   ' a la que se le envie al finalizar'"
                          }
                        ],
                        attrs: { for: "name" }
                      },
                      [_vm._v(" Nombre ")]
                    ),
                    _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        type: "text",
                        placeholder: "Ingrese nombre del destinatario",
                        maxlength: "250",
                        id: "name",
                        name: "name",
                        danger: _vm.errors.has("new-distribution.name"),
                        "danger-text": _vm.errors.first("new-distribution.name")
                      },
                      model: {
                        value: _vm.newDistribution.name,
                        callback: function($$v) {
                          _vm.$set(_vm.newDistribution, "name", $$v)
                        },
                        expression: "newDistribution.name"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "label",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value:
                              "Correo al que sera distribuido el expediente una ves finalice",
                            expression:
                              "'Correo al que sera distribuido el expediente una ves finalice'"
                          }
                        ],
                        attrs: { for: "newDistributionMail" }
                      },
                      [_vm._v(" Correo ")]
                    ),
                    _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "'required|email'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        type: "email",
                        placeholder: "Ingrese correo del destinatario",
                        maxlength: "250",
                        id: "newDistributionMail",
                        name: "email",
                        danger: _vm.errors.has("new-distribution.email"),
                        "danger-text": _vm.errors.first(
                          "new-distribution.email"
                        )
                      },
                      model: {
                        value: _vm.newDistribution.mail,
                        callback: function($$v) {
                          _vm.$set(_vm.newDistribution, "mail", $$v)
                        },
                        expression: "newDistribution.mail"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8" }, [
      _c("h4", [_vm._v("Distribución")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }